import { validatePairedAmountFilters } from 'shared/components/CustomTable/filters/pairedAmountFilters';

const AMOUNT_FIELDS = ['total_tvac', 'remaining_balance'];

export const handleCreditNoteFilters = <T extends { debtor?: unknown }>(filters: T) =>
  validatePairedAmountFilters(AMOUNT_FIELDS)(
    filters.debtor ? { ...filters, debtor: undefined } : { ...filters },
  );
